module.exports = __webpack_public_path__ + "img/fire.4b21da4e.png";